module.exports = __webpack_public_path__ + "static/media/chevron-down.9c444c79.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/chevron-down.svg
// module id = 243
// module chunks = 0